import styled, { css, keyframes } from 'styled-components';

import { TThemeType } from '_style/style';

interface StyledDotProps {
  $color: keyof TThemeType['color'];
  $delay: number;
  $size: number;
}

const bounce = ($size: number) => keyframes`
  0%,
  80%,
  100% {
    opacity: 0.3;
    transform: translateY(0);
  }

  40% {
    opacity: 1;
    transform: translateY(-${$size / 2}px);
  }
`;

export const StyledLoadingDots = styled.div<{ $size: number }>`
  display: inline-flex;
  flex-shrink: 0;
  gap: ${({ $size }) => `${$size}px`};
  align-items: center;
  height: ${({ $size }) => `${$size * 1.5}px`};
`;

export const StyledDot = styled.span<StyledDotProps>`
  flex-shrink: 0;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  background-color: ${({ $color, theme }) => theme.color[$color]};
  border-radius: 50%;

  ${({ $delay, $size }) => css`
    animation: ${bounce($size)} 1.2s ease-in-out infinite;
    animation-delay: ${$delay}ms;
  `}
`;
